export default "__VITE_ASSET__Q65GwBbN__"